module.exports = __webpack_public_path__ + "static/media/beep.13620510.mp3";